<template>
    <div>
        <bc-dialog :value="supervisor_pin_dialog" max-width="300px" transition="dialog-bottom-transition" overlay="false" scrollable>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ current_user.has_pin ? "Change Pin" : "Set Pin" }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="invokeMethod($event)" action="close" :dialog-status="supervisor_pin_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="supervisorPinForm">
                        <v-layout row wrap>
                            <v-flex xs12 v-if="current_user.has_pin">
                                <v-text-field v-model="current_pin" label="Current Pin *"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="new_pin" label="New Pin *"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="confirm_new_pin" label="Confirm Pin *"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="close()">Cancel</v-btn>
                    <v-btn color="primary" @click="submitPin()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import AppConfig from "Constants/AppConfig";
import axios from "axios";
//TODO: custom filter for the v-combo to search for email as well as name
export default {
    data() {
        return {
            current_pin: "",
            new_pin: "",
            confirm_new_pin: "",
            supervisor_pin_dialog: false,
        };
    },
    methods: {
        ...mapActions(["submitUpdateSupervisorPin"]),
        close() {
            this.supervisor_pin_dialog = false;
            this.current_pin = "";
            this.new_pin = "";
            this.confirm_new_pin = "";
        },
        openDialog() {
            this.supervisor_pin_dialog = true;
        },
        submitPin() {
            if (this.new_pin !== this.confirm_new_pin) {
                this.$store.commit("showSnackbar", {
                    text: "Pin and Confirm Pin do not match",
                    color: "error",
                });
                return;
            } else {
                this.submitUpdateSupervisorPin({ current_pin: this.current_pin, pin: this.new_pin }).then((response) => {
                    if (response.success) {
                        this.$emit("eventname", true);
                        this.close();
                    } else {
                        this.$store.commit("showSnackbar", {
                            text: response.data.message,
                            color: "error",
                        });
                    }
                });
            }
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.AppActiveUser.user,
            user_is_dev: (state) => state.AppActiveUser.user_is_dev,
        }),
    },
};
</script>
